import Annotation from './components/Annotation';
export { default as defaultProps } from './components/defaultProps';

export default Annotation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-image-annotation/es/index.js
// module id = 2010
// module chunks = 0